'use es6'; // /* eslint-disable no-unused-vars */

import { LAYOUT_EDITOR_OPTIONS_FETCH } from 'DesignData/actions/ActionTypes';
import { save } from 'DesignData/actions/LayoutEditorOptions';
let currentOptions = null;
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  /*
   * Autosave changes
   */

  const state = getState();
  const {
    layoutEditorOptions
  } = state;

  if (currentOptions === null) {
    // This will occur when redux starts and gets the default state from the reducer.
    currentOptions = layoutEditorOptions;
  } else if (currentOptions !== layoutEditorOptions && result.type !== LAYOUT_EDITOR_OPTIONS_FETCH) {
    // You __must__ dispatch the save *after* updating the `currentOptions` reference
    // otherwise you'll have an infinite loop.
    currentOptions = layoutEditorOptions;
    dispatch(save());
  }

  return result;
});